module.exports = __webpack_public_path__ + "img/customCircle.522c583.jpg";